import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '48px 0',
        '& > span': {
            fontSize: '48px',
            fontWeight: '800',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '30px',
            },
        },
        [theme.breakpoints.down('md')]: {
            padding: '40px 0',
            paddingBottom: 0
        },
    },
    scrollContainer: {
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
    },
    scrollContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        animation: '$marquee 40s linear infinite',
        width: 'max-content',
    },
    '@keyframes marquee': {
        '0%': {
            transform: 'translateX(0)',
        },
        '100%': {
            transform: 'translateX(-50%)',
        }
    },
    card: {
        background: '#18181B',
        padding: '24px',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        margin: '0 12px',
        '& > img': {
            width: 158,
            height: 180,
            objectFit: 'cover',
            borderRadius: '12px',
            overflow: 'hidden',
            '&:first-child': {
                marginRight: '16px',
            },
            [theme.breakpoints.down('md')]: {
                width: 110,
                height: 125,
            },
        }
    }
}));

export default useStyles;